<template>
  <div v-if="topic" class="topic-wrapper" :class="[`mq-${$mq}`]">
    <topics-a-z/>


    <div class="topic-content">
      <div class="stories-wrapper">
        <div class="story-section-header">
          <h2>Stories / {{ meta.name }}</h2>
        </div>
        <div class="stories">
          <div v-for="story in stories" :key="`story-${story.slug}`" class="story">
            <router-link v-if="story.image" :to="`/story/${story.slug}`" class="story-image">
              <div onerror="this.style.display='none'" class="inner-image">
                <img :src="story.image" :alt="story.name" />
              </div>   
            </router-link>

            <div class="story-content-wrapper">
              <router-link :to="`/story/${story.slug}`">
                <div class="story-content">
                  <h4 v-if="story.name" class="story-name">{{ story.name }}</h4>
                  <div class="story-meta-wrapper">
                    <span class="story-meta">
                      <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13.5938 7.5C13.5937 9.11616 12.9517 10.6661 11.8089 11.8089C10.6661 12.9517 9.11616 13.5938 7.5 13.5938C5.88384 13.5938 4.33387 12.9517 3.19107 11.8089C2.04827 10.6661 1.40625 9.11616 1.40625 7.5C1.40625 5.88384 2.04827 4.33387 3.19107 3.19107C4.33387 2.04827 5.88384 1.40625 7.5 1.40625C9.11616 1.40625 10.6661 2.04827 11.8089 3.19107C12.9517 4.33387 13.5937 5.88384 13.5938 7.5ZM0 7.5C0 9.48912 0.790176 11.3968 2.1967 12.8033C3.60322 14.2098 5.51088 15 7.5 15C9.48912 15 11.3968 14.2098 12.8033 12.8033C14.2098 11.3968 15 9.48912 15 7.5C15 5.51088 14.2098 3.60322 12.8033 2.1967C11.3968 0.790176 9.48912 0 7.5 0C5.51088 0 3.60322 0.790176 2.1967 2.1967C0.790176 3.60322 0 5.51088 0 7.5ZM6.79688 3.51562V7.5C6.79688 7.73438 6.91406 7.9541 7.11035 8.08594L9.92285 9.96094C10.2451 10.1777 10.6816 10.0898 10.8984 9.76465C11.1152 9.43945 11.0273 9.00586 10.7021 8.78906L8.20312 7.125V3.51562C8.20312 3.12598 7.88965 2.8125 7.5 2.8125C7.11035 2.8125 6.79688 3.12598 6.79688 3.51562Z" fill="black"/>
                      </svg>
                      {{ story.last_published | ago }}
                    </span>
                    <span class="story-meta">{{ story.cx_pub }} sources</span>
                    <div class="item-mood" :class="getMood(story.mood).code">
                      <div class="item-mood-marker"></div>
                      <span>{{ getMood(story.mood).name }}</span>
                    </div>
                  </div>
                  <span v-if="story.stack" class="story-stack">{{ story.stack }}</span>
                  <span v-if="story.synopsis" class="story-stack">{{ story.synopsis }}</span>
                </div>
              </router-link>

              <ul class="meta" :title="story.last_published | date">
                <li v-for="(topic, idx) in story.topics.slice(0, 3)" :key="`story-${idx}-${story.slug}-topic-${topic.topic_code}`">
                  <router-link :to="`/topic/${topic.topic_code}`">
                    {{ topic.topic_name }}
                  </router-link>
                </li>
              </ul>    
            </div>       
          </div>
        </div>
      </div>

      <div class="topic-aside">
        <div class="topic-header">
          <div class="topic-header-content">
            <div v-if="meta.image && meta.image !== 'https://nourished.news'" class="image">
              <img :src="meta.image" :alt="meta.name" onerror="this.parentElement.style.display='none'"/>
            </div>
            <div class="inner-stack">
              <h1>{{ meta.name }}</h1>
              <h2 v-if="meta.byline">{{ meta.byline | ucfirst }}</h2>
            </div>
          </div>

          <div class="inner-stack">
            <p v-html="getMetaSynth"></p>
            <!-- <button v-if="getMetaSynth && !showReadMore" class="ghost read-more-btn" @click="showReadMore = true">Read more</button>
            <button v-if="getMetaSynth && showReadMore" class="ghost read-more-btn" @click="showReadMore = false">Read less</button> -->
          </div>

          <div class="related" v-if="getRelatedTopics.length > 0">
            <h3>Also related to this topic</h3>
            <div class="related-topics">
              <TopicTag v-for="topic in getRelatedTopics" :key="`related-${topic.topic_code}`" :data-key="topic.topic_code" :data="topic" :to="`/topic/${topic.topic_code}`"/>
            </div>
          </div>
        </div>

        <div class="aside-group" v-if="isDesktop">
          <div v-if="isSignedIn" class="aside-section">
            <Dial />
          </div>

          <div class="aside-section qr">
            <QRCode />
          </div>
        </div>
      </div>
    </div>
  </div>
  <Loading v-else/>
</template>

<script>
import API from "app/axios";
import TopicsAZ from 'app/components/Topics/AZ.vue';
import TopicTag from 'app/components/_v5/grid-elements/meta/TopicTag.vue' 
import QRCode from '@/components/v5/desktop/elements/QRCode.vue';
import Dial from '@/components/v5/desktop/elements/Dial.vue';

export default {
  components: {
    TopicsAZ,
    TopicTag,
    QRCode,
    Dial
  },

  data() {
    return {
      fetched: false,
      fetchFailed: false,
      showReadMore: false,
    };
  },


  computed: {
    isSignedIn() {
      return this.$store.getters.isLoggedIn; 
    },
    isDesktop() {
      return this.$layoutEngine.isDesktop;
    },

    topicCode() {
      return this.$route.params.name;
    },
    topic() {
      return this.$store.getters.getTopic(this.topicCode);
    },
    meta() {
      return this.topic?.meta || {};
    },
    stories() {
      return [...this.topic?.stories].sort((a, b) => {
        return new Date(a.last_published) > new Date(b.last_published) ? -1 : 1;
      }) || [];
    },
    topicArticles() {
      return this.$store.getters.getTopicArticles(this.topicCode);
    },
    getRelatedTopics() {
      return [...this.topic.topics].sort((a, b) => {
        return a.stories?.sx > b.stories?.sx ? -1 : 1;
      }).filter(a => a.topic_code != this.topicCode).slice(0, 6);
    },
    getMetaSynth() {
      if (this.showReadMore) {
        return this.meta.synth;
      }

      const synth = this.meta.synth || '';
      return synth.length > 250 ? synth.slice(0, 250) + '…' : synth;
    }
  },


  methods: {
    getMood(mood) {
      if (mood < -0.25) {
        return {
          code: 'negative',
          name: 'Negative'
        }
      } else if (mood > 0.25) {
        return {
          code: 'positive',
          name: 'Positive'
        }
      }

      return {
        code: 'neutral',
        name: 'Neutral'
      }
    },
    
    getTopic() {
      API.getTopic(this.topicCode)
      // .then(() => {
      //   this.fetched = true;
      // }).catch(() => {
      //   this.fetched = true;
      //   this.fetchFailed = true;
      // });
    },

    getTopicArticles() {
      // API.getTopicArticles(this.topicCode)
      // .then(() => {
      //   this.fetched = true;
      // }).catch(() => {
      //   this.fetched = true;
      //   this.fetchFailed = true;
      // });
    },
  },


  mounted() {
    this.getTopic();
    this.getTopicArticles();
  },


  watch: {
    $route() {
      this.getTopic();
      // this.getTopicArticles();
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/assets/scss/v5.scss';

.topic-wrapper {
  position: relative;
  max-width: 1400px;
  margin: 0 auto;

  @media(min-width: 1400px) {
    border-left: 1px solid rgba($neutral-400, 0.25);
    border-right: 1px solid rgba($neutral-400, 0.25);
  }
}

.topic-content {
  display: grid;
  grid-template-columns: $desktop-grid-main $desktop-grid-aside;
  height: calc($desktop-grid-height - 75px);
  overflow: hidden;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    height: auto;
  }

  .topic-aside {
    display: flex;
    flex-direction: column;
    height: calc($desktop-grid-height - 75px);
    flex: 1;
    overflow-y: auto;
    -ms-overflow-style: none;
    overflow: -moz-scrollbars-none;
    &::-webkit-scrollbar {
      display: none;
    }

    @media (max-width: 900px) {
      grid-row: 1;
      height: auto;
    }
  }

  .aside-group {
    position: sticky;
    bottom: 0;
    border-top: 1px solid rgba($neutral-400, 0.25);
    background: $neutral-600;

    .darkmode & {
      background: $neutral-100;
    }
  }

  .aside-section {
    padding: 1rem;
    border-bottom: 1px solid rgba($neutral-400, 0.25);

    &.qr {
      padding: 1rem 2rem;

       @media (max-width: 820px) {
        padding: 1rem 1rem;
      }
    }
  }

  .topic-header {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    gap: 1rem;
    padding: 2rem 2rem;
    max-width: 1000px;
    background: rgba($neutral-400, 0.03);
    // border-bottom: 1px solid rgba($neutral-400, 0.25);

    @media (max-width: 820px) {
      padding: 2rem 1rem;
    }

    .image {
      margin-right: 1.5rem;
      width: 8rem;
      height: 8rem;
      border-radius: 500px;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 500px;
      }
    }

    .topic-header-content {
      display: flex;
      align-items: center;

      h1 {
        font-family: 'Bralwer';
        font-size: 2.2rem;
        font-weight: normal;
      }

      h2 {
        font-size: 0.9rem;
        line-height: 140%;
      }
    }

    .inner-stack {
      display: flex;
      align-items: flex-start;
      flex-direction: column;
      gap: 0.5rem;  
      flex: 1;

      p {
        margin-bottom: 0.5rem;
      }
    }

    .read-more-btn {
      font-weight: normal;
      border-radius: 0;
      color: $neutral-400;
      border-bottom: 1px solid $neutral-400;
      padding-bottom: 2px;
      transition: all 0.2s ease-in-out;

      &:hover {
        color: $neutral-100;
        border-bottom: 1px solid $neutral-100;

        .darkmode & {
          color: $neutral-600;
          border-bottom: 1px solid $neutral-600;
        }
      }
    }
  }

  .related {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin-top: 1rem;

    h3 {
      font-size: 0.8rem;
      font-weight: normal;
      color: $neutral-400;
    }

    .related-topics {
      display: flex;
      flex-wrap: wrap;
      gap: 0.5rem;
    }
  }

  .stories-wrapper {
    display: flex;
    flex-direction: column;
    border-right: 1px solid rgba($neutral-400, 0.25);
    flex: 1;
    overflow-y: auto;
    -ms-overflow-style: none;
    overflow: -moz-scrollbars-none;
    &::-webkit-scrollbar {
      display: none;
    }

    .story-section-header {
      position: sticky;
      top: 0;
      padding: 2rem 2rem 2rem 2rem;
      width: 100%;
      backdrop-filter: blur(10px);
      background: rgba($neutral-600, 0.8);
      border-bottom: 1px solid rgba($neutral-400, 0.25);

      .darkmode & {
        background: rgba($neutral-100, 0.8);
      }

      @media (max-width: 820px) {
        grid-template-columns: 1fr;
        padding: 2rem 1rem;
      }

      h2 {
        font-family: 'Brawler';
        font-size: 1.6rem;
        font-weight: normal;
        margin-bottom: 0.25rem;
      }
    }
  }

  .stories { 
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
    padding: 2rem 2rem 2rem 2rem;

    @media (max-width: 820px) {
      padding: 0 1rem 2rem 1rem;
    }

    @media (max-width: 620px) {
      grid-template-columns: 1fr 1fr;
    }

    @media (max-width: 525px) {
      grid-template-columns: 1fr;
    }

    .story-content-wrapper {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 100%;
    }

    .story {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      width: 100%;
      background: rgba($neutral-400, 0.05);
      border-radius: 10px;
      color: $neutral-100;
      border-left: 2px solid transparent;
      cursor: pointer;
      transition: all 0.2s ease-in-out;

      .darkmode & {
        color: $neutral-600;
      }

      &:hover {
        background: rgba($neutral-400, 0.15);
      }

      .story-image {
        width: 100%;
      }

      .inner-image {
        width: 100%;
        height: 10rem;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-top-left-radius: 6px;
          border-top-right-radius: 6px;
        }
      }

      .story-content {
        display: flex;
        flex-direction: column;
        gap: 0.4rem;
        flex: 1;
        padding: 1.5rem 1rem 1rem 1rem;

        .story-meta-wrapper {
          display: flex;
          align-items: center;
          margin-bottom: 0.25rem;

          .story-meta {
            display: flex;
            align-items: center;
            font-size: 0.8rem;
            color: $neutral-400;

            svg {
              margin-top: 1px;
              margin-right: 0.2rem;
              
              path {
                fill: $neutral-400;
              }
            }

            &:not(:last-child) {
              &::after{
                content: '|';
                margin: 0 0.4rem;
                color: $neutral-400;
              }
            }
          }
        }

        .story-name {
          font-size: 1.1rem;
          line-height: 140%;
        }

        .story-meta {
          display: flex;
          align-items: center;
          gap: 0.25rem;
          font-size: 0.8rem;
          color: $neutral-400;
          margin-bottom: 0.25rem;

          svg {
            margin-top: 1px;
            
            path {
              fill: $neutral-400;
            }
          }
        }

        .item-mood {
          display: flex;
          align-items: center;
          gap: 0.3rem;
          background: none;
          padding-bottom: 2px;

          .item-mood-marker {
            width: 7px;
            height: 7px;
            border-radius: 500px;
          }

          span {
            display: inline-block;
            font-size: 0.8rem;
            color: $neutral-400;
            padding-bottom: 1px;
          }

          &.positive {
            color: $green-tone-3;
            .item-mood-marker {
              background: $green-tone-3;
            }
          }

          &.neutral {
            color: $blue-tone-3;
            .item-mood-marker {
              background: $blue-tone-3;
            }
          }

          &.negative {
            color: $red-tone-3;
            .item-mood-marker {
              background: $red-tone-3;
            }
          }
        }

        .story-stack {
          font-size: 0.8rem;
          color: $neutral-400;
          line-height: 140%;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
      }

      .meta {
        display: flex;
        flex-wrap: wrap;
        font-size: 0.8rem;
        gap: 0.5rem;
        padding: 1rem 1rem 1.5rem 1rem;

        li {
          color: $neutral-400;
          border-bottom: 1px solid $neutral-400;
          padding-bottom: 2px;
          transition: all 0.2s ease-in-out;

          &:hover {
            color: $neutral-100;
            border-bottom: 1px solid $neutral-100;

            .darkmode & {
              color: $neutral-600;
              border-bottom: 1px solid $neutral-600;
            }
          }
        }
      }
    }
  }
}

// .story-card {
//   display: flex;
//   margin: .25em;
//   border: 1px solid rgba($neutral-500, 1);
//   border-radius: .25em;
//   overflow: hidden;
//   cursor: pointer;

//   .darkmode & {
//     border: 1px solid rgba($neutral-300, 1);
//   }

//   .image {
//     max-width: 20vw;
//     border-radius: .25em 0 0 .25em;
//     overflow: hidden;

//     img {
//       max-width: 100%;
//       object-fit: cover;
//     }
//   }
//   .body {
//     padding: .25em;

//     .meta {
//       display: flex;
//       flex-wrap: nowrap;
//       overflow: hidden;

//       li {
//         white-space: nowrap;
//         margin-left: .5em;
//         padding-left: .5em;
//         font-size: 0.7em;
//         border-left: 1px solid rgba($neutral-500, .5);

//         .darkmode {
//           border: 1px solid rgba($neutral-300, .5);
//         }

//         &:first-child {
//           border: none;
//         }
//       }
//     }
//   }
// }
</style>